module.exports = __webpack_public_path__ + "media/images/aba-pay-acbaab25c2843eab04a0f02dd174d55d.png";